<template>
  <section class="jsk-block block-cta">
    <div class="container jsk-block jsk-block-round bg-secondary">
      <div class="row">
       <div class="col-12 col-lg-8 offset-lg-2 text-center">
          <p class="h5 px-3">{{ ctaText }}</p>
          <router-link :to=ctaRoute class="btn btn-xl btn-primary btn-round mr-2 text-uppercase mt-4">
              {{ ctaBtn }}
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  name: "cta",
  props: ["ctaText", "ctaBtn", "ctaRoute"]
};
</script>